import React, { createContext, useContext, useRef } from 'react';

const RefContext = createContext();

export const RefProvider = ({ children }) =>
{
    const companyRef = useRef(null);
    const visionRef = useRef(null);
    const weRef = useRef(null);
    const contactRef = useRef(null);
    const indexRef = useRef(null);
    const saganRef = useRef(null);

    const handleScrollTo = (ref) =>
    {
        if (ref && ref.current)
        {
            const navbarHeight = 80; // Altura del navbar en píxeles
            const elementPosition = ref.current.getBoundingClientRect().top + window.scrollY - navbarHeight;

            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
        }
    };

    return (
        <RefContext.Provider value={{ indexRef, handleScrollTo, companyRef, visionRef, weRef, contactRef }}>
            {children}
        </RefContext.Provider>
    );
};

export const useRefs = () => useContext(RefContext);
